import { ROUTES } from 'utils/constants/routes';
import clearUserCookies from 'utils/cookies/clearUserCookies';

export const LogOut = () => {
  clearUserCookies();
  window.location.href = ROUTES.login;
};
